import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { colors, Button } from '@material-ui/core';
import { SectionHeader } from 'components/molecules';
import { Section } from 'components/organisms';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: colors.indigo[500],
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center right',
    [theme.breakpoints.up('md')]: {
      backgroundImage: 'url(/images/illustrations/bg-remote-working.svg)',
    },
  },
  textWhite: {
    color: 'white',
  },
  sectionHeader: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '50%',
    },
  },
}));

const AboutBottom = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Section>
        <SectionHeader
          title={<span className={classes.textWhite}>Standard program</span>}
          subtitle={
            <span className={classes.textWhite}>
              For students seeking a quality, accredited high school diploma, 
              we offer a premier program that is academically challenging and enriching. 
              With a variety of core courses and electives to choose from, 
              our standard diploma program offers a rigorous education that can be earned on a student’s own terms.
            </span>
          }
          ctaGroup={[
            <Button variant="contained" size="large">
              Get started
            </Button>,
          ]}
          align="left"
          className={classes.sectionHeader}
          disableGutter
          data-aos="fade-up"
        />
      </Section>
    </div>
  );
};

AboutBottom.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default AboutBottom;
